import wixWindow from 'wix-window'
import wixUsers from 'wix-users'
import wixLocation from 'wix-location'
import wixSeo from 'wix-seo'
import { getFeatures, getUsersNames, addVote, removeVote, getVotes } from 'backend/FeatureFlow'
import { TYPES, STATUSES, BI_INPUTS } from 'public/featureFlowConsts.js'
import {
	styleHtmlForDisplay,
	replcaeCurlyBracketsWithImageTags,
	checkIfUserIsPrivate,
	createPrivateUserProfile,
	checkIfUserIsMissing,
	createMissingUserProfile
} from 'public/utils'
import { truncate } from 'public/truncate.js'
import TimeAgo from 'javascript-time-ago'
import TimeAgoEn from 'javascript-time-ago/locale/en'

import { BI_EVENTS } from 'public/biConsts'
import { sendBi } from 'public/biModule'

// wishlist default constatnts
const wishlistDefaultStatuses = ['Pending']
const wishlistAllStatuses = ['Reassigned', 'Pending', 'Planning', 'InDevelopment', 'RollingOut', 'Released']
const wishlistDefaultSource = 'Community'
const wishlistDefaultSort = 'votesCount'
const pageSize = 10

let statusElement

let initialPageTitle

TimeAgo.addLocale(TimeAgoEn)
const timeAgo = new TimeAgo('en-US')

$w.onReady(function () {
	whenFeatureItemIsReady(populateFeatureItemWithFeatureData)
	initiateUIelements()
	
	const features = getInitialFeatures().then(results => {
		bindFeaturesToUI(results)
		return results
	})

	if (wixWindow.rendering.env === 'browser') {
		// browser
	} else {
		return features
	}
})

// const setNextAndPrevRelLinks = () => {
// 	const relLinks = createNextAndPrevRelLinks(wixLocation.query, wixLocation.url, wixSeo.links)
// 	wixSeo.setLinks(relLinks)
// }

const initiateUIelements = () => {
	statusElement = createStatusUIElement()
	initiatePagination()
	handleTypeSelect()
	handleSortSelect()
	handleStatusSelect()
	handleSearchSubmit()
}

const initiatePagination = () => {
	const currentPage = Number(wixLocation.query.page) || 1
	$w('#pagination').currentPage = currentPage
	initialPageTitle = wixSeo.title

	addCurrentPageToTitle(currentPage)

	$w('#pagination').onChange(() => {

		const newCurrentPage = $w('#pagination').currentPage
		if (newCurrentPage === 1) {
			wixLocation.queryParams.remove(['page'])
		} else {
			wixLocation.queryParams.add({
				page: newCurrentPage
			})
			//session.setItem('currentPageURL', wixLocation.url)
		}
	})

	wixLocation.onChange(() => {
		const currentPage = Number(wixLocation.query.page) || 1
		//console.log('currentPage', currentPage)
		addCurrentPageToTitle(currentPage)
		$w('#pagination').currentPage = currentPage
		scrollToTop()
		updateFeaturesList()
		setPaginationCoverLinks()
	})
}

const resetPagination = () => {
	$w('#pagination').currentPage = 1
}

const addCurrentPageToTitle = (currentPage) => {
	const title = (currentPage === 1) ? initialPageTitle : `${initialPageTitle} - Page ${currentPage}`
	wixSeo.setTitle(title)
}

const setPaginationCoverLinks = () => {

	const pageNumber = $w('#pagination').currentPage
	const totalPages = $w('#pagination').totalPages
	const nextPageNumber = pageNumber + 1
	const prevPageNumber = pageNumber - 1
	const urlWithoutQueryParams = wixLocation.url.split('?')[0]

	if (nextPageNumber <= totalPages) {
		const nextUrl = `${urlWithoutQueryParams}?page=${nextPageNumber}`
		$w('#paginationNextCover').link = nextUrl
		$w('#paginationNextCover').show()
	} else {
		$w('#paginationNextCover').hide()
	}

	if (prevPageNumber > 0) {
		const prevUrl = (prevPageNumber === 1) ? urlWithoutQueryParams : `${urlWithoutQueryParams}?page=${prevPageNumber}`
		$w('#paginationPrevCover').link = prevUrl
		$w('#paginationPrevCover').show()
	} else {
		$w('#paginationPrevCover').hide()
	}

}

const bindFeaturesToUI = (results) => {

	const features = convertPrivateUsersToObjects(results.items)
	$w('#featuresRepeater').data = features
	$w('#loadingStateBox').changeState('showContent')
	updateUserNames(features)

	setPaginationTotalPagesFromResults(results)
	setPaginationCoverLinks()

	return features
}

const convertPrivateUsersToObjects = (features) => {
	const processesFeatures = features.map(feature => {
		const isUserMissing = checkIfUserIsMissing(feature.submittingUser)
		if (isUserMissing) {
			feature.submittingUser = createMissingUserProfile()
		} else {
			const isUserPrivate = checkIfUserIsPrivate(feature.submittingUser)
			if (isUserPrivate || typeof feature.submittingUser === 'undefined') {
				feature.submittingUser = createPrivateUserProfile(feature.submittingUser)
			}
		}
		return feature
	})
	return processesFeatures
}

const setPaginationTotalPagesFromResults = (results) => {
	const totalPages = (results.totalCount > 0) ? Math.ceil(results.totalCount / pageSize) : 1
	$w('#pagination').totalPages = totalPages
}

const scrollToTop = () => {
	return $w('#topAnchor').scrollTo()
}

const updateUserNames = async (features) => {
	const usersExtraData = await getUsersExtraDataByFeatures(features)
	updateUserNamesFromUsersExtraData(usersExtraData)
}

const getUsersExtraDataByFeatures = async (features) => {
	const userIDs = features.map(feature => {
		return (feature.submittingUser._id) ? feature.submittingUser._id : ''
		// return (feature.submittingUser) ? feature.submittingUser : ''
	})

	const usersExtraData = await getUsersNames(userIDs)
	return usersExtraData
}

const updateUserNamesFromUsersExtraData = (usersExtraData) => {
	const keyedUserNames = {}
	usersExtraData.forEach(userExtraData => {
		keyedUserNames[userExtraData.user] = userExtraData.name
	})

	$w('#featuresRepeater').forEachItem(($item, feature) => {
		if (!feature.submittingUser) return
		// const userName = keyedUserNames[feature.submittingUser]
		const userName = keyedUserNames[feature.submittingUser._id]
		const userNameIsAlreadyDisplayed = ($item('#creationInfo').text.includes(', '))
		if (userName && !userNameIsAlreadyDisplayed) {
			$item('#creationInfo').text += `, ${userName}`
		}
	})
}

const getInitialFeatures = async () => {

	const pageNumber = (wixLocation.query.page) ? parseInt(wixLocation.query.page, 10) : 1
	const type = null
	const sort = wishlistDefaultSort
	const statuses = wishlistDefaultStatuses
	const search = null
	const pageIndex = pageNumber - 1
	const source = wishlistDefaultSource
	const excludeSubmittingUser = false

	const queryDefinition = { pageSize, pageIndex, type, sort, statuses, search, source, excludeSubmittingUser }
	return await getFeatures(queryDefinition)
}

const updateFeaturesList = async () => {
	const results = await getDesiredFeatures()
	bindFeaturesToUI(results)
	return results
}

const getDesiredFeatures = async () => {

	const pageNumber = $w('#pagination').currentPage
	const selectedType = $w('#selectType').value
	const type = (selectedType !== 'all') ? selectedType : null
	const sort = $w('#selectSort').value
	const selectedStatus = statusElement.getValue()
	const statuses = (selectedStatus === 'all') ? wishlistAllStatuses : selectedStatus
	const search = $w('#inputSearch').value
	const pageIndex = pageNumber - 1
	const source = wishlistDefaultSource
	const excludeSubmittingUser = false

	const queryDefinition = { pageSize, pageIndex, type, sort, statuses, search, source, excludeSubmittingUser }
	return await getFeatures(queryDefinition)
}

const whenFeatureItemIsReady = (callback) => {
	$w('#featuresRepeater').onItemReady(callback)
}

const populateFeatureItemWithFeatureData = ($item, feature) => {

	const { title, description, status, submissionDate, submittingUser, userProfileFallback, commentsCount } = feature

	$item('#featureTitle, #featureDescription, #creationInfo, #userImage, #statusTitle, #statusColor, #votesCount, #commentsCountNumber, #commentsCountIcon').onClick(() => {
		wixLocation.to(feature['link-featureflow-features-title'])
	})
	// for SEO purposes we add a link (<a> tag) to one of the elements
	// so Google's crawler can follow the link
	$item('#userImage').link = feature['link-featureflow-features-title']

	const descriptionWithImageTags = replcaeCurlyBracketsWithImageTags(description)
	const styledDescription = styleHtmlForDisplay(descriptionWithImageTags)
	const shortStyledDescription = truncate(styledDescription, 175, { ellipsis: '…' })

	// feature data
	$item('#featureTitle').text = title
	$item('#featureDescription').html = shortStyledDescription

	if (commentsCount) {
		$item('#commentsCountNumber').text = commentsCount.toString()
		$item('#commentsCountNumber, #commentsCountIcon').show()
	}

	// status
	$item('#statusTitle').text = STATUSES[status].label
	$item('#statusColor').style.backgroundColor = STATUSES[status].color || 'grey'

	let voteElement = createVoteUIElement($item)

	initiateVoteElement(voteElement, feature._id)

	voteElement.onBeforeChange(async () => {
		if (!wixUsers.currentUser.loggedIn) {
			await wixUsers.promptLogin()
		}
		return wixUsers.currentUser.loggedIn
	})

	voteElement.onChange(() => {
		const didUserVoteForThisFeature = voteElement.isChecked()
		didUserVoteForThisFeature ? addVote(feature._id) : removeVote(feature._id)
	})

	// const displayDate = submissionDate.toDateString().slice(4).toUpperCase()
	const displayDate = timeAgo.format(submissionDate).toUpperCase()
	$item('#creationInfo').text = displayDate

	if (userProfileFallback && userProfileFallback.imageUrl) {
		$item('#userImage').src = userProfileFallback.imageUrl
	}
}

const initiateVoteElement = async (voteElement, featureId) => {
	const votes = await getVotes(featureId)
	voteElement
		.setVotesAmout(votes.count)
		.setCheckBox(votes.didUserVote)
		.enable()
}

const handleTypeSelect = () => {
	$w('#selectType').onChange(() => {

		sendBi(BI_EVENTS.TYPE_CHANGED, Object.assign({
			topic: statusElement.getValue(),
			type: $w('#selectType').value,
			release_date: 'all'
		}, BI_INPUTS))

		resetPagination()
		updateFeaturesList()
	})
}

const handleSortSelect = () => {
	$w('#selectSort').onChange(() => {
		resetPagination()
		updateFeaturesList()
	})
}

const handleStatusSelect = () => {
	statusElement.onChange(() => {

		sendBi(BI_EVENTS.STATUS_CHANGED, Object.assign({
			topic: statusElement.getValue(),
			type: $w('#selectType').value
		}, BI_INPUTS))

		resetPagination()
		updateFeaturesList()
	})
}

const handleSearchSubmit = () => {

	const submitSearchForm = async () => {

		$w('#messageSearch').hide()
		resetPagination()
		const results = await updateFeaturesList()

		sendBi(BI_EVENTS.SEARCH, Object.assign({
			origin: 'page search',
			text: $w('#inputSearch').value,
			num_of_results: results.totalCount,
			topic: statusElement.getValue(),
			type: $w('#selectType').value
		}, BI_INPUTS))

		if (results.totalCount === 0) {
			$w('#messageSearch').show()
		}
	}

	$w('#inputSearch').onKeyPress(event => {
		if (event.key === 'Enter') submitSearchForm()
	})
	$w('#buttonSearch').onClick(submitSearchForm)
}

// ------ status element ------

const createStatusUIElement = () => {
	const buttonStyle = {
		normal: {
			backgroundColor: '#fff',
			color: '#000'
		},
		selected: {
			backgroundColor: '#000',
			color: '#fff'
		}
	}

	let selectedButtonId = 'buttonStatusPending'
	let onChangeSubscriber

	const buttonIDsToValues = {
		buttonStatusAll: 'all',
		buttonStatusReleased: 'Released',
		buttonStatusRollingOut: 'RollingOut',
		buttonStatusInDevelopment: 'InDevelopment',
		buttonStatusPending: 'Pending',
	}

	const buttonIDs = Object.keys(buttonIDsToValues)
	buttonIDs.forEach(buttonId => {
		if ($w(`#${buttonId}`).isVisible) {
			$w(`#${buttonId}`).onClick(event => {
				switchSelectedButton(buttonId)
				selectedButtonId = buttonId
				if (onChangeSubscriber) onChangeSubscriber(event)
			})
		}
	})

	const switchSelectedButton = clickedButtonId => {
		$w(`#${selectedButtonId}`).style.backgroundColor = buttonStyle.normal.backgroundColor
		$w(`#${selectedButtonId}`).style.color = buttonStyle.normal.color
		$w(`#${clickedButtonId}`).style.backgroundColor = buttonStyle.selected.backgroundColor
		$w(`#${clickedButtonId}`).style.color = buttonStyle.selected.color
	}

	return {
		getValue: () => buttonIDsToValues[selectedButtonId],

		onChange: (newOnChangeSubscriber) => {
			onChangeSubscriber = newOnChangeSubscriber
		}

	}
}

// TODO Rewrite as functional programing
// ------ vote element ------

const createVoteUIElement = ($item) => {
	let checked = false
	let enabled = false
	let onBeforeChangeSubscriber
	let onChangeSubscriber
	let votesCount = 0

	$item('#voteElement').onClick(async () => {

		if (onBeforeChangeSubscriber) {
			const canContinue = await onBeforeChangeSubscriber()
			if (!canContinue) return
		}

		if (!enabled) return

		setCheckBox(!checked)

		setVotesAmout((checked) ? votesCount + 1 : votesCount - 1)

		if (onChangeSubscriber) return onChangeSubscriber()
	})

	return {

		onBeforeChange: newOnBeforeChangeSubscriber => {
			onBeforeChangeSubscriber = newOnBeforeChangeSubscriber
		},

		onChange: newOnChangeSubscriber => {
			onChangeSubscriber = newOnChangeSubscriber
		},

		isChecked: () => checked,

		setCheckBox: setCheckBox,

		enable: () => {
			enabled = true
			showLayer((checked) ? '#voteChecked' : '#voteUnchecked')
			return this
		},

		disable: () => {
			enabled = false
			showLayer('#voteDisabled')
			return this
		},

		setVotesAmout: setVotesAmout,

	}

	function setCheckBox(newChecked) {
		checked = newChecked
		$item('#voteText').text = (checked) ? 'Voted!' : 'Vote'
		showLayer((checked) ? '#voteChecked' : '#voteUnchecked')
		return this
	}

	function setVotesAmout(newVotesCount) {
		votesCount = newVotesCount
		$item('#votesCount').text = votesCount.toString()
		return this
	}

	function showLayer(itemId) {
		$item('#voteChecked').hide()
		$item('#voteUnchecked').hide()
		$item('#voteDisabled').hide()
		$item(itemId).show()
	}
}